import React, { useEffect, useState } from 'react';
import styles from './AdminMobileMainPage.module.css';
import P from 'components/P';
import Container from 'layouts/container/Container';
import FlexChild from 'layouts/flex/FlexChild';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import {
    mainBgColor,
    mainBodyHeight,
    mainPadd,
    mainPadd2,
    pageCommonGap1,
    pageCommonPadd,
    pageEH2FontSize,
    pageH1FontSize,
    pagePaddTopH,
} from 'routes/adminMobile/constraints/AdminConst';
import AdminFavMenu from 'routes/adminMobile/components/AdminFavMenu';
import AdminMobileContentBox from '../components/common/AdminMobileContentBox';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import backIcon from 'routes/vendorRe/images/back_icon.png';
import useCustomAdminMobileMove from '../hooks/useCustomAdminMobileMove';
import { requester } from 'App';
import { combineDuplicates, filterDataByThisWeek } from 'routes/vendorRe/commonFn/vendorPurchaseOrder';
import AdminMobileAllStoreSaleList from '../components/AdminMobileAllStoreSaleList';

// 즐겨찾기 메뉴 데이터(추후 즐겨찾기 메뉴 사항 변동 가능성)
import favMenuList from 'routes/adminMobile/commonVar/favMenuList';

const AdminMobileMainPage = () => {
    const [isMounted, setMounted] = useState(false);
    const {moveToStoreSale} = useCustomAdminMobileMove();

    const [saleData, setSaleData] = useState();
    // const saleData = [];

    useEffect(()=> {
        setMounted(true);
    }, []);
 
    useEffect(() => {
        if (isMounted) {
            /* 주간 판매량 베스트 전체 */
            requester.findAllAdminPurchaseOrder((result) => {
                // 
    
                // 오늘 자 기준, [월~일] 주간의 데이터 가져오기
                const filteredData = filterDataByThisWeek(result.data);
                // 
    
                // 여러 주문 중에 중복되는 아이템 합치기
                const combinedSaleData = combineDuplicates(filteredData);
                
    
                // 정렬된 데이터 설정
                const sortedSaleData = combinedSaleData.sort((a, b) => b.quantity - a.quantity);
                setSaleData(sortedSaleData); // 판매 데이터 설정
            });
        }
    }, [isMounted]);

    //

    return (
        <div style={{paddingTop: pagePaddTopH}}>
            <Container padding={pageCommonPadd} height={mainBodyHeight}>
                <VerticalFlex gap={pageCommonGap1} backgroundColor={mainBgColor}>
                    <FlexChild alignItems="flex-start" height={"initial"} padding={mainPadd}>
                        {/* H1 헤더 */}
                        <P size={pageH1FontSize}>PUFFU 관리자 1</P>
                    </FlexChild>
                    <FlexChild height={"initial"} padding={mainPadd}>
                        {/* 즐겨찾기 메뉴 */}
                        <AdminFavMenu favMenuList={favMenuList} />
                    </FlexChild>
                    <FlexChild height={"initial"} padding={mainPadd}>
                        {/* 점포별 매출 현황 이동 버튼 */}
                        <AdminMobileContentBox>
                            <div style={{cursor: "pointer"}} onClick={() => moveToStoreSale()}>
                                <HorizontalFlex>
                                    <FlexChild>
                                        <P size={pageEH2FontSize}>점포별 매출 현황</P>
                                    </FlexChild>
                                    <FlexChild justifyContent="flex-end">
                                        <img className={styles.moveIcon} src={backIcon} alt='페이지 이동' />
                                    </FlexChild>
                                </HorizontalFlex>
                            </div>
                        </AdminMobileContentBox>
                    </FlexChild>
                    <FlexChild>
                        <VerticalFlex backgroundColor={mainBgColor} padding={mainPadd2}>
                            <FlexChild>
                                {/* 전 매장 판매량 BEST */}
                                <AdminMobileContentBox flexStart>
                                    <VerticalFlex>
                                        <FlexChild alignItems={"flex-start"}>
                                            <div className={styles.borderBot}>
                                                <P size={pageEH2FontSize}>전 매장 판매량 BEST</P>
                                            </div>
                                        </FlexChild>
                                        <FlexChild>
                                            {/* 판매량 리스트 */}
                                            <AdminMobileAllStoreSaleList saleData={saleData} />
                                        </FlexChild> 
                                    </VerticalFlex>
                                </AdminMobileContentBox>
                            </FlexChild>
                        </VerticalFlex>
                    </FlexChild>
                </VerticalFlex>
            </Container>
        </div>
    );
};

export default AdminMobileMainPage;
